/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adControllerCreate } from '../fn/ad/ad-controller-create';
import { AdControllerCreate$Params } from '../fn/ad/ad-controller-create';
import { adControllerDelete } from '../fn/ad/ad-controller-delete';
import { AdControllerDelete$Params } from '../fn/ad/ad-controller-delete';
import { adControllerFindOne } from '../fn/ad/ad-controller-find-one';
import { AdControllerFindOne$Params } from '../fn/ad/ad-controller-find-one';
import { adControllerSearch } from '../fn/ad/ad-controller-search';
import { AdControllerSearch$Params } from '../fn/ad/ad-controller-search';
import { adControllerUpdate } from '../fn/ad/ad-controller-update';
import { AdControllerUpdate$Params } from '../fn/ad/ad-controller-update';
import { AdDto } from '../models/ad-dto';
import { AdSearchResponseDto } from '../models/ad-search-response-dto';

@Injectable({ providedIn: 'root' })
export class AdService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adControllerSearch()` */
  static readonly AdControllerSearchPath = '/api/ad/search';

  /**
   * ad 알림 목록 조회.
   *
   * ad 알림 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerSearch$Response(params: AdControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AdSearchResponseDto>> {
    return adControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * ad 알림 목록 조회.
   *
   * ad 알림 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerSearch(params: AdControllerSearch$Params, context?: HttpContext): Observable<AdSearchResponseDto> {
    return this.adControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdSearchResponseDto>): AdSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `adControllerFindOne()` */
  static readonly AdControllerFindOnePath = '/api/ad/{id}';

  /**
   * ad 알림 상세 조회.
   *
   * ad 알림 상세 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerFindOne$Response(params: AdControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<AdDto>> {
    return adControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * ad 알림 상세 조회.
   *
   * ad 알림 상세 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerFindOne(params: AdControllerFindOne$Params, context?: HttpContext): Observable<AdDto> {
    return this.adControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdDto>): AdDto => r.body)
    );
  }

  /** Path part for operation `adControllerUpdate()` */
  static readonly AdControllerUpdatePath = '/api/ad/{id}';

  /**
   * ad 알림 수정.
   *
   * ad 알림을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adControllerUpdate$Response(params: AdControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * ad 알림 수정.
   *
   * ad 알림을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adControllerUpdate(params: AdControllerUpdate$Params, context?: HttpContext): Observable<boolean> {
    return this.adControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adControllerCreate()` */
  static readonly AdControllerCreatePath = '/api/ad';

  /**
   * ad 알림 생성.
   *
   * ad 알림을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adControllerCreate$Response(params: AdControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdDto>> {
    return adControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * ad 알림 생성.
   *
   * ad 알림을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adControllerCreate(params: AdControllerCreate$Params, context?: HttpContext): Observable<AdDto> {
    return this.adControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdDto>): AdDto => r.body)
    );
  }

  /** Path part for operation `adControllerDelete()` */
  static readonly AdControllerDeletePath = '/api/ad';

  /**
   * ad 알림 삭제.
   *
   * ad 알림을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerDelete$Response(params: AdControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * ad 알림 삭제.
   *
   * ad 알림을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adControllerDelete(params: AdControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.adControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
